// src/api/apiKeys.ts

import { axiosPrivate } from "./axios";
import type {
  ApiKey,
  ApiKeyCreateRequest,
  ApiKeyCreateResponse,
  ApiKeyStats,
  ApiKeyUpdateRequest,
  ApiKeyRecentUsage,
} from "@/types/apiKeys";

// List all API keys
export const getApiKeys = async (orgId?: number, signal?: AbortSignal) => {
  const params = orgId ? `?org_id=${orgId}` : "";
  const response = await axiosPrivate.get(`/auth/api-keys${params}`, {
    signal,
  });
  return response.data as {
    message: string;
    data: ApiKey[];
  };
};

// Get organization's API keys
export const getOrgApiKeys = async (orgId: number, signal?: AbortSignal) => {
  const response = await axiosPrivate.get(`/auth/api-keys/org/${orgId}`, {
    signal,
  });
  return response.data as {
    message: string;
    organization: {
      id: number;
      name: string;
    };
    data: ApiKey[];
  };
};

// Create API key
export const createApiKey = async (data: ApiKeyCreateRequest) => {
  const response = await axiosPrivate.post("/auth/api-keys", data);
  return response.data as ApiKeyCreateResponse;
};

// Update API key
export const updateApiKey = async (id: number, data: ApiKeyUpdateRequest) => {
  const response = await axiosPrivate.patch(`/auth/api-keys/${id}`, data);
  return response.data as {
    message: string;
    data: ApiKey;
  };
};

// Revoke (delete) API key
export const revokeApiKey = async (id: number) => {
  const response = await axiosPrivate.delete(`/auth/api-keys/${id}`);
  return response.data as {
    message: string;
  };
};

// Get API key statistics
export const getApiKeyStats = async (orgId?: number, signal?: AbortSignal) => {
  const params = orgId ? `?org_id=${orgId}` : "";
  const response = await axiosPrivate.get(`/auth/api-keys/stats${params}`, {
    signal,
  });
  return response.data as {
    message: string;
    stats: ApiKeyStats;
    recent_usage: ApiKeyRecentUsage[];
  };
};